import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as MapActions from './map.action';
import { MapService } from './map.service';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { MapMarker } from '../../models/map/map';


export interface MapStateModel {
    MapMarker: MapMarker;
}

@State<MapStateModel>({
    name: 'mapState',
    defaults: {
      MapMarker: null,
    }
  })

  @Injectable()

  export class MapState {

    constructor(
      private helperService: HelperService,
      private mapService: MapService,
      private bannerService: BannerService
    ) { }

  @Selector()
  static MapMarker(state: MapStateModel) {
    return state.MapMarker;
  }



  @Action(MapActions.Geocode)
  geocode(
      context: StateContext<MapStateModel>,
      action: MapActions.Geocode
    ) {
      this.mapService.geocode().subscribe((ret) => {
      },
      (error) => {

        this.helperService.SaveException('MapActions.Geocode', error);

        this.bannerService.error('something went wrong');
        });
    }

  @Action(MapActions.GetLocation)
  getLocation(
        context: StateContext<MapStateModel>,
        action: MapActions.GetLocation
      ) {
        context.getState();
        context.setState(
          patch({
            MapMarker: null
          })
        );

        this.mapService.getLocation(action.Location).subscribe((ret) => {
          if (ret.Success) {
            const marker: MapMarker = {
              Lat: ret.Location.Lat,
              Lng: ret.Location.Lng,
              Draggable: false,
              Title: '',
              Www: '',
              Distance: ret.Distance
            };
            context.setState(
              patch({
                MapMarker: marker
              })
            );
          }
        },
        (error) => {

          this.helperService.SaveException('MapActions.Geocode', error);
          this.bannerService.error('something went wrong');
          });
      }

}

